import { motion } from "framer-motion";
import ProjectCard from "../ProjectCard/ProjectCard";

export default function Projects() {

  const projects = [
    {
      title: "Developer Productivity Dashboard",
      desc: "Full-stack dashboard using React, Flask, APIs and Pandas for engineering metrics visualization.",
      github: "https://github.com/developwithmanish",
      live: "#"
    },

    {
      title: "MCQ Checker with Voice Output",
      desc: "Python-based MCQ checking system with spoken feedback and automation support.",
      github: "https://github.com/developwithmanish",
      live: "#"
    },

    {
      title: "PDF Tools",
      desc: "Utilities for PDF searching, conversion and quick content access.",
      github: "https://github.com/developwithmanish",
      live: "#"
    },

    {
      title: "Coaching Website with Result System",
      desc: "Dynamic website system with student result access and server hosting.",
      github: "https://github.com/developwithmanish",
      live: "#"
    }
  ];

  return (
    <motion.section
      id="projects"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >

      <h2 className="text-3xl font-bold mb-6">
        Projects
      </h2>

      <div className="grid md:grid-cols-2 gap-6">

        {projects.map((project) => (
          <ProjectCard
            key={project.title}
            project={project}
          />
        ))}

      </div>

    </motion.section>
  );
}